<template>
  <slot data-bs-toggle="modal" :data-bs-target="'#BatchExtend' + TbtnId"></slot>
  <div
    class="modal fade"
    :id="'BatchExtend' + TbtnId"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    style="background: rgba(0, 0, 0, 0.8)"
  >
    <div class="modal-dialog modal-ext modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            학습점수지급
          </h5>
        </div>
        <div
          style="text-align: center"
          class="modal-body"
          v-if="
            students.some(
              (student) =>
                student.subscriptions && !student.subscriptions.length
            )
          "
        >
          리스트에 미사용 혹은 MyPath 학생이 있습니다. 작업을 계속할 수
          없습니다.
        </div>
        <div class="modal-body" style="text-align: left" v-else>
          <!--<template v-if="this.$root.guiPerm != 'ROOT'">-->
          <i class="bi bi-info-circle"></i> 변경 이력은 변경 이력은 회원관리 -> 학습점수관리 -> 학습점수내역 확인
          가능합니다.<br />
          <!--</template
          >-->          
          <template
            ><i class="bi bi-info-circle"></i>
            <strong
              >리스트에 미사용 학생이 있습니다. 작업을 계속할 수
              없습니다.</strong
            ><br
          /></template>
          <!--
          <i class="bi bi-info-circle"></i> MyPath 학생은 변경신청을 할 수
          없으며 MyPath+ChildU 상품 신청 시 ChildU 만 변경됩니다.--><br />         


          <table class="table">
                <tbody>
                    <tr>
                    <th>선택회원</th>
                    <td style="text-align:center;">                       
                        <select
                        class="hidtype"   
                        v-model="Psub.id"              
                        ><option value="" selected>선택한 회원 확인!!</option>
                        <template
                            
                            v-for="(student, i) in students" v-bind:key="i"
                        >
                            <option :value="student.id" >
                                {{ student.name }}({{ student.username }})
                            </option>
                        </template>
                        </select>
                       / {{ students.length }}명
                     </td>
                     <th>유형</th>
                    <td colspan="3" style="text-align:center;" >
                        <select class="hidtype" v-model="Psub.chrGubun">
                        <option value="P" selected>적립</option>
                        <option value="M">차감</option>
                        </select>
                    </td>
                    </tr>
                    <tr>
                    <th>종류</th>
                    <td style="text-align:center;">
                        <select class="hidtype" v-model="Psub.chrPType" >
                        <option value="" selected>선택</option>
                        <option value="A">ALPHA</option>
                        <option value="C">CARAT</option>
                        <option value="F">FAME</option>                
                        </select>
                    </td>
                    <th style="width:13%">점수</th>
                    <td style="text-align:center;width:10%;padding-left: 10px;">            
                        <select class="hidtype" @input="doChange($event.target.value)" v-model="Psub.setPoint" >
                        <option value="" selected>선택</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="300">300</option>
                        <option value="400">400</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                        <option value="2000">2000</option>
                        <option value="3000">3000</option>
                        <option value="5000">5000</option>
                        <option value="self">직접입력</option>
                        </select>
                    </td>
                    <td style="text-align:center;width:18%">       
                        <input type="number" class="form-control" style='width:70%;margin-left:20px'  v-model="Psub.intPoint" id = "intPoint" readonly @input="inputNumber($event)"
                        oninput="this.value = this.value.replace(/[^0-9.]/g, '')" >
                        
                    </td>
                    </tr>
                    <tr>
                    <th>내용</th>
                    <td colspan="5" style="text-align:center;">
                        <input type="text" class="form-control" style='width:95%;margin-left:20px' placeholder="여기에 내용을 작성 .." maxlength = "20"
                        v-model="Psub.strHistory" />
                    </td>            
                    </tr>          
                </tbody>
                </table>
                <div style="text-align:left; font-size:14px; line-height:10px; margin:0px; padding:10px 20px; " >
                <p style="color:red">[관리 안내]</p>
                <p>- 선택된 모든 회원에게 일괄 처리되므로 관리할 내용과 회원이 정확한지 꼭 확인해 주세요!</p> 
              </div>
              <div class="flex_center">     
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> 닫기</button>
                <button type="button" class="btn btn-danger" @click="addPoint()">등록</button>
              </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "PointRegMultiple",
  props: {
    students: Array,
    btnId: String,
  },
  mounted() {
      this.chData = this.PointRegMultiple;
      //console.log(this.Psub.bookclubs);
      this.Psub = {
        "chrGubun": "P",
        "chrPType": "",
        "intPoint": "",
        "strHistory": ""                
       }
    },
    watch: {
      
      sub(){
        alert('Psub has been updated')
              this.chData = this.PointRegMultiple;
      }
      
    },
  data: function () {
    return {
      TbtnId: this.btnId || Math.random().toString().substr(2, 5),
      creating:true,
      active: false, 
      Psub:{
            "id" : "",
            "chrGubun": "P",
            "chrPType": "",
            "setPoint": "",
            "intPoint": "",
            "strHistory": ""                
            },
            
            changedData: {
              
            },
            product: null,
            disable_init_search: true,
            pointRequest: [],
    };
  },
  methods: {
    reset(){
      this.Psub.id=""; 
      this.Psub.chrGubun="P"; 
      this.Psub.chrPType=""; 
      this.Psub.setPoint=""; 
      this.Psub.intPoint=""; 
      this.Psub.strHistory=""; 
                           
        
    },
    doChange(value) {
       
          if (value == "self") {          
            this.Psub.setPoint = "self";
            this.Psub.intPoint = "";
            document.getElementById("intPoint").readOnly  = false;          
          } else {
            this.Psub.setPoint = value;
            this.Psub.intPoint = value;
            document.getElementById("intPoint").readOnly  = true;     
          }
        
      },
    addPoint() {
      this.intMemberID = [];
      this.students.forEach((student, i) => {
        this.intMemberID[i]  = student.id ;
      });
      //console.log(this.intMemberID);
      //return;

    if(this.intMemberID==""){
    alert('회원을 선택해주세요.');   
    return;
  }if(this.Psub.chrPType==""){
    alert('종류를 선택해주세요.');   
    return;
  }
  if(this.Psub.intPoint==""){
    alert('점수를 입력해주세요.');   
    return;
  }
  var data = {
    chrGubun: this.Psub.chrGubun,
    chrPType: this.Psub.chrPType,
    intPoint: this.Psub.intPoint,
    strHistory: this.Psub.strHistory,
    intMemberID: this.intMemberID,
  };
  //console.log(data);
  if (!confirm("선택한 모든회원의 학습점수를 일괄지급 하시겠습니까?")) return;
  var send = axios({
    method: this.creating ? "post" : "patch",
    url:
       "/students/pointIn_multi" +      
      (!this.creating ? "/" + this.$route.params.article : ""),
    data: data,
  });
  send.then((response) => {
    if (response.data.error) {
      $.notify(
        {
          // options
          message: "처리할 수 없습니다 " + response.data.error,
        },
        {
          // settings
          type: "danger",
          z_index: 9999,
        }
      );
    } else {
      $.notify(
        {
          // options
          message: "처리되었습니다",
         
        },
        {
          // settings
          type: "success",
          z_index: 9999,
        }
      );

      // this.$router.push(
      //   this.creating
      //     ? response.data.id.toString()
      //     : "../" + response.data.id.toString()
      // );
      this.reset();
      this.$parent.search();
      (bootstrap.Modal.getInstance(document.getElementById('BatchExtend' + this.TbtnId))).hide();
      
    }
  });
},

inputNumber(event){
      this.result = event.target.value
    }

  },
};
</script>

<style></style>
